import { styled } from "../../../styles/stitches.config"

export default styled("div", {
  minHeight: "100vh",
  "@lg": {
    paddingLeft: "calc(100vw - 100%)", // prevents horizontal page shift when vertical scrollbar is visible
  },
})
